// extracted by mini-css-extract-plugin
export default {"offer-box":"RnDOffer_offer-box__PRdRx","shadow-effect":"RnDOffer_shadow-effect__hx+wg","image":"RnDOffer_image__h9lDS","offerlists":"RnDOffer_offerlists__6BgGp"};